import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// Failures
export const GetFailuresVoiceRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailuresVoice`,
	params: { userId, role },
	hasLoading: false
});

export const SetFailureVoiceValidInvalidRequest = (userId, id) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/SetFailureVoiceValidInvalid`,
	params: { userId, id }
});

export const GetFailureVoiceDetailsRequest = (id, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailureVoiceDetails`,
	params: { id, userId }
});

export const GetFailureVoiceCommentsRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetFailureVoiceComments`,
	params: { id }
});

export const SetFailureVoiceDetailsRequest = (trackerVoiceDetailsDto, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/EditFailureVoiceDetails`,
	data: { trackerVoiceDetailsDto, userId }
});

export const AddVoiceCommentRequest = (id, userId, comment) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}FailuresTracker/AddFailureVoiceComment`,
	params: { id, userId, comment }
});

export const ExportFailuresVoiceRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/ExportFailuresVoice`,
	params: { userId, role }
});

export const GetVoiceLevelsRequest = (type, level) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}FailuresTracker/GetVoiceLevels`,
	params: { type, level }
});

// Layer3
export const GetLayer3Request = (filenameMoc, filenameMtc, initialTimestamp, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3`,
	params: { filenameMoc, filenameMtc, initialTimestamp, userId }
});

export const GetLayer3MessageMoRequest = (id, date, side, userId, filename) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Message`,
	params: { id, date, side, userId, filename }
});

export const GetLayer3MessageMtRequest = (id, date, side, userId, filename) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Message`,
	params: { id, date, side, userId, filename }
});

export const GetLayer3FailureRequest = (id) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Failure`,
	params: { id }
});

export const GetLayer3DriveTestRequest = (userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3DriveTest`,
	params: { userId, kpi, filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime }
});

export const GetLayer3KpisRequest = (filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Layer3/GetLayer3Kpis`,
	params: { filenameMoc, filenameMtc, failureSide, initialTimestamp, eventTime }
});
